export default {
  get: {

  },
  post: {
    getStoreList: '/store/list',// 门店列表
    getStoreDetail: '/store/detail',// 获取门店详情
    getVerifyStoreRecord: '/store/get-verify-log',// 门店审核记录
    isShowTs: '/store/is-show-ts',// 是否显示团膳
    storeCreate: '/store/create', // 创建门店
    editSubmit: '/store/save',// 编辑门店
    close: '/store/close', //停用门店
    open: '/store/open', // 启用门店
    getRelList: '/store/rel-list',// 可关联门店列表
    exportStoreList: '/store/export-list',
    getListByName: '/store/get-list-by-name',
    updateAddress:'/store/update-address',
    uploadImgFiles:"/system/upload-img-files",
    isCanCreateStoreByGroupId: "/store/is-can-create-store-by-group-id",
    getPageRelList: "/store/get-page-rel-list"
  }
}